/* eslint-disable @typescript-eslint/no-explicit-any */

import { IconType } from '../index';

const IconMognoAfricano = (props: any) => {
  return (
    <svg
      width="auto"
      height="26"
      viewBox="0 0 29 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5556 32C14.969 32 15.3041 31.6649 15.3041 31.2515V24.7273H22.041C25.7559 24.7273 28.7778 21.7905 28.7778 18.1818C28.7778 14.9425 26.3436 12.2457 23.1594 11.7266C24.7544 10.5288 25.7837 8.65163 25.7837 6.54545C25.7837 2.93679 22.7617 0 19.0468 0H10.0644C6.34946 0 3.32753 2.93679 3.32753 6.54545C3.32753 8.65163 4.35677 10.5288 5.95179 11.7266C2.76758 12.2457 0.333374 14.9425 0.333374 18.1818C0.333374 21.7905 3.3553 24.7273 7.07022 24.7273H13.8071V31.2515C13.8071 31.6649 14.1422 32 14.5556 32ZM1.83045 18.1818C1.83045 20.989 4.18169 23.2727 7.07022 23.2727H13.8071V21.392L9.53513 17.2415C9.24237 16.957 9.24237 16.4975 9.53513 16.2131C9.82789 15.9286 10.3008 15.9286 10.5936 16.2131L13.8071 19.3352V11.2102L9.53513 7.05966C9.24237 6.77521 9.24237 6.3157 9.53513 6.03125C9.82789 5.7468 10.3008 5.7468 10.5936 6.03125L13.8071 9.15341V5.09091C13.8071 4.68963 14.1415 4.36364 14.5556 4.36364C14.9697 4.36364 15.3041 4.68963 15.3041 5.09091V9.15341L18.5176 6.03125C18.8103 5.7468 19.2833 5.7468 19.5761 6.03125C19.8688 6.3157 19.8688 6.77521 19.5761 7.05966L15.3041 11.2102V19.3352L18.5176 16.2131C18.8103 15.9286 19.2833 15.9286 19.5761 16.2131C19.8688 16.4975 19.8688 16.957 19.5761 17.2415L15.3041 21.392V23.2727H22.041C24.9295 23.2727 27.2807 20.989 27.2807 18.1818C27.2807 15.3746 24.9295 13.0909 22.041 13.0909H19.0468C18.6327 13.0909 18.2983 12.7649 18.2983 12.3636C18.2983 11.9624 18.6327 11.6364 19.0468 11.6364C21.9353 11.6364 24.2866 9.35263 24.2866 6.54545C24.2866 3.73828 21.9353 1.45455 19.0468 1.45455H10.0644C7.17585 1.45455 4.8246 3.73828 4.8246 6.54545C4.8246 9.35263 7.17585 11.6364 10.0644 11.6364C10.4785 11.6364 10.8129 11.9624 10.8129 12.3636C10.8129 12.7649 10.4785 13.0909 10.0644 13.0909H7.07022C4.18169 13.0909 1.83045 15.3746 1.83045 18.1818Z"
        fill={props.color}
      />
    </svg>
  );
};

IconMognoAfricano.defaultProps = {
  color: 'black',
} as IconType;

export default IconMognoAfricano;
